import React from "react";
import { Answers, Step } from "../types";

export function SingleSelectStep({
	options,
	onSelect,
	layout = "grid",
}: {
	options: { id: string; label: string; isSelected: boolean }[];
	onSelect: (value: any) => void;
	layout?: "grid" | "list";
}) {
	return (
		<div className={`options-grid ${layout === "list" ? "list-layout" : ""}`}>
			{options.map((option) => {
				return (
					<button
						key={option.id}
						className={`option-button ${option.isSelected ? "selected" : ""}`}
						onClick={() => onSelect(option.id)}
					>
						<span dangerouslySetInnerHTML={{ __html: option.label }} />
						{option.isSelected && <span className="checkmark">✓</span>}
					</button>
				);
			})}
		</div>
	);
}
